/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FeatureTileDto
 */
export interface FeatureTileDto {
    /**
     * 
     * @type {string}
     * @memberof FeatureTileDto
     */
    id?: string | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof FeatureTileDto
     */
    title: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof FeatureTileDto
     */
    description: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof FeatureTileDto
     */
    buttonText: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof FeatureTileDto
     */
    tooltip: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof FeatureTileDto
     */
    iconKey: string;
    /**
     * 
     * @type {string}
     * @memberof FeatureTileDto
     */
    colorBackground: string;
    /**
     * 
     * @type {string}
     * @memberof FeatureTileDto
     */
    colorBackgroundHover: string;
    /**
     * 
     * @type {string}
     * @memberof FeatureTileDto
     */
    colorText: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof FeatureTileDto
     */
    linkUrl: { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof FeatureTileDto
     */
    enabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof FeatureTileDto
     */
    order?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof FeatureTileDto
     */
    showFooter: boolean;
}

/**
 * Check if a given object implements the FeatureTileDto interface.
 */
export function instanceOfFeatureTileDto(value: object): value is FeatureTileDto {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('buttonText' in value) || value['buttonText'] === undefined) return false;
    if (!('tooltip' in value) || value['tooltip'] === undefined) return false;
    if (!('iconKey' in value) || value['iconKey'] === undefined) return false;
    if (!('colorBackground' in value) || value['colorBackground'] === undefined) return false;
    if (!('colorBackgroundHover' in value) || value['colorBackgroundHover'] === undefined) return false;
    if (!('colorText' in value) || value['colorText'] === undefined) return false;
    if (!('linkUrl' in value) || value['linkUrl'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('showFooter' in value) || value['showFooter'] === undefined) return false;
    return true;
}

export function FeatureTileDtoFromJSON(json: any): FeatureTileDto {
    return FeatureTileDtoFromJSONTyped(json, false);
}

export function FeatureTileDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeatureTileDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'],
        'description': json['description'],
        'buttonText': json['buttonText'],
        'tooltip': json['tooltip'],
        'iconKey': json['iconKey'],
        'colorBackground': json['colorBackground'],
        'colorBackgroundHover': json['colorBackgroundHover'],
        'colorText': json['colorText'],
        'linkUrl': json['linkUrl'],
        'enabled': json['enabled'],
        'order': json['order'] == null ? undefined : json['order'],
        'showFooter': json['showFooter'],
    };
}

export function FeatureTileDtoToJSON(json: any): FeatureTileDto {
    return FeatureTileDtoToJSONTyped(json, false);
}

export function FeatureTileDtoToJSONTyped(value?: FeatureTileDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'description': value['description'],
        'buttonText': value['buttonText'],
        'tooltip': value['tooltip'],
        'iconKey': value['iconKey'],
        'colorBackground': value['colorBackground'],
        'colorBackgroundHover': value['colorBackgroundHover'],
        'colorText': value['colorText'],
        'linkUrl': value['linkUrl'],
        'enabled': value['enabled'],
        'order': value['order'],
        'showFooter': value['showFooter'],
    };
}

